module.exports = __webpack_public_path__ + "img/Blood Cells.c807657.png";